import React, { useEffect, useState } from "react";

import Clipboard from "react-clipboard.js";
import axios from "axios";
import { toast } from "react-toastify";

import { URL_PAGAMENTO } from "../../config/urls";
import { Typography, Row, Col, Card, Result, Spin, Image, Input, Button, Descriptions, Table } from 'antd';
import { CopyOutlined } from '@ant-design/icons';

export default function TabelaDetalhesCobranca(props) {

  const [carregando, setCarregando] = useState(true);
  const [cobranca, setCobranca] = useState(null);
  const [numParcelas, setNumParcelas] = useState(0);
  const [numParcelasPagas, setNumParcelasPagas] = useState(0);
  const [parcelasCobranca, setParcelasCobranca] = useState([]);
  const [base64, setBase64] = useState("");
  const [copiaCola, setCopiaCola] = useState("");
  const [erroPixExpirado, setErroPixExpirado] = useState(false);

  useEffect(() => {
    if (!props?.pedidoSelecionado?.cobranca) {
      return;
    }

    const cobrancaSelecionada = props.pedidoSelecionado.cobranca;
    setCobranca(cobrancaSelecionada);
    setNumParcelas(cobrancaSelecionada.numParcelas || 0);
    setNumParcelasPagas(cobrancaSelecionada.numParcelasPagas || 0);

    const formaPagamento = (cobrancaSelecionada.formaPagamento || "").toLowerCase();
    const precisaGerarPix = formaPagamento === "pix";

    if (precisaGerarPix && !cobrancaSelecionada.cobrancaPaga) {
      setCarregando(true);
      setErroPixExpirado(false);
      getPix(cobrancaSelecionada);
    } else {
      setCarregando(false);
      // setNumParcelas(cobrancaSelecionada.parcelasCobranca.length);
      // const numParcelasPagas = cobrancaSelecionada.parcelasCobranca.filter((parcela) => {
      //   return parcela.dataPagamento != null;
      // }).length;
      // setNumParcelasPagas(numParcelasPagas);
      //
      // cobrancaSelecionada.parcelasCobranca.sort((a, b) => {
      //   return a.numero < b.numero;
      // });
      // setParcelasCobranca(cobrancaSelecionada.parcelas);
      // const numProxParcela = getNumProxParcela(cobrancaSelecionada.parcelas);
      // if (numProxParcela) {
      //   getPix(cobrancaSelecionada.extRef, numProxParcela)
      // } else {
      //   setCarregando(false)
      // }
    }
  }, [props.pedidoSelecionado]);

  async function getPix(cobrancaSelecionada) {
    if (!cobrancaSelecionada?.extRef) {
      console.warn("Cobrança sem extRef para gerar PIX.");
      setCarregando(false);
      return;
    }
    try {
      const response = await axios.post(`${URL_PAGAMENTO}/gerar-pix`, {
        cobrancaId: cobrancaSelecionada.extRef,
        numProxParcela: cobrancaSelecionada.numParcelas ? cobrancaSelecionada.numParcelas : null
      }, { headers: { "Authorization": "Bearer " + sessionStorage.getItem("tokenPagamento") } });

      if (response.data) {
        const data = response.data;

        setBase64(data.encodedImage || "");
        setCopiaCola(data.payload || "");
        setErroPixExpirado(!data.encodedImage);
      }
    } catch (erro) {
      console.error("Erro ao gerar PIX:", erro);
      setErroPixExpirado(true);
      toast.error("Não foi possível gerar o QR Code PIX. O pagamento pode estar expirado ou já foi pago.");
    } finally {
      setCarregando(false);
    }
  }

  // Helper for splitting dates
  function splitReverseJoin(split, join, data) {
    return data.split(split).reverse().join(join);
  }

  const { Title, Text, Paragraph } = Typography;

  const columnsParcelas = [
    {
      title: '#',
      dataIndex: 'numero',
      key: 'numero',
      render: (text, record) => (
        <div>
          Parcela #{text}
          {record.linkAcesso && (
            <div style={{ marginTop: 5 }}>
              <a href={record.linkAcesso} target="_blank" rel="noreferrer">
                <i className="fa fa-external-link-square-alt" style={{ marginRight: 5 }} />
                Abrir link
              </a>
            </div>
          )}
        </div>
      ),
    },
    {
      title: 'Data de vencimento',
      dataIndex: 'dataVencimento',
      key: 'dataVencimento',
      render: (text) => splitReverseJoin("-", "/", text),
    },
    {
      title: 'Data de pagamento',
      dataIndex: 'dataPagamento',
      key: 'dataPagamento',
      render: (text) => text ? splitReverseJoin("/", "-", text) : "-",
    },
  ];

  return (
    <div style={{ marginTop: 20 }}>
      <Title level={5}>Informações para o pagamento:</Title>
      {cobranca != null ? (
        <Row gutter={[24, 24]}>
          {/* Status / Action Column */}
          {(!cobranca.parcelasCobranca || cobranca.parcelasCobranca.length === 0) && (
            <Col xs={24} md={12}>
              <Card bordered={false} className="box-shadow-card">
                {props.pedidoSelecionado.status === "Pedido cancelado" ? (
                  <Result
                    status="error"
                    title="Este pedido foi cancelado!"
                  />
                ) : cobranca.valor > Math.ceil(cobranca.valorJaPago) ? (
                  <>
                    {carregando ? (
                      <div style={{ textAlign: "center", padding: 40 }}>
                        <Spin size="large" />
                      </div>
                    ) : base64.length ? (
                      <div style={{ textAlign: "center" }}>
                        <Title level={4}>Pague com o Pix:</Title>
                        <div style={{ margin: "20px auto", maxWidth: 200 }}>
                          <Image src={`data:image/jpeg;base64,${base64}`} alt="QRCODE Pix" />
                        </div>
                        <Text strong>Pague com o Pix Copia e Cola</Text>
                        <div style={{ marginTop: 10, display: "flex", gap: 8 }}>
                          <Input value={copiaCola} readOnly />
                          <Button
                            icon={<CopyOutlined />}
                            onClick={() => {
                              navigator.clipboard.writeText(copiaCola);
                              toast.success("Copiado com sucesso!");
                            }}
                          >
                            Copiar
                          </Button>
                        </div>
                      </div>
                    ) : erroPixExpirado ? (
                      <Result
                        status="warning"
                        title="QR Code PIX expirado ou indisponível"
                        subTitle="O QR Code PIX pode ter expirado ou o pagamento já foi realizado. Entre em contato com o suporte se precisar de ajuda."
                      />
                    ) : null}
                  </>
                ) : (
                  <Result
                    status="success"
                    title={props.pedidoSelecionado.status === "Pagamento vinculado a comissão" ? "Pagamento vinculado a comissão" : "Este pedido já está pago!"}
                  />
                )}
              </Card>
            </Col>
          )}

          {/* Details Column */}
          <Col xs={24} md={(!cobranca.parcelasCobranca || cobranca.parcelasCobranca.length === 0) ? 12 : 24}>
            <Card bordered={false} className="box-shadow-card">
              <Descriptions title="Detalhes" column={1} bordered>
                <Descriptions.Item label="Tipo de pagamento">{cobranca.formaPagamento}</Descriptions.Item>
                <Descriptions.Item label="Valor total">{props.formatarMoedaBr(cobranca.valor)}</Descriptions.Item>
                <Descriptions.Item label="Valor pago">{props.formatarMoedaBr(cobranca.valorJaPago)}</Descriptions.Item>
                {cobranca.formaPagamento && cobranca.formaPagamento.toLowerCase() !== 'pix' && (
                  <Descriptions.Item label="Parcelas">
                    {cobranca.numParcelasPagas}/{cobranca.numParcelas} {cobranca.numParcelas === 1 ? "paga" : "pagas"}
                  </Descriptions.Item>
                )}
              </Descriptions>
            </Card>
          </Col>

          {/* Installments Table Row */}
          {cobranca.parcelasCobranca && cobranca.parcelasCobranca.length > 0 && (
            <Col span={24}>
              <Card title="Parcelas" bordered={false} className="box-shadow-card">
                <Table
                  dataSource={parcelasCobranca}
                  columns={columnsParcelas}
                  rowKey="numero"
                  pagination={false}
                />
              </Card>
            </Col>
          )}

        </Row>
      ) : null}
    </div>
  );
}                